/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import GetStarted from './GetStarted';
import { useNavigate } from 'react-router-dom';

export default function GetStartedPage() {
    const navigate = useNavigate();
    const handleBackClick = () => navigate(`/client/welcome`);
    const handleNextClick = () => navigate(`/client/company`);

    return (
        <GetStarted
            handleBackClick={handleBackClick}
            handleNextClick={handleNextClick}
        />
    );
}
